(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/core/assets/javascripts/events/hide-fullscreen-event.js') >= 0) return;  svs.modules.push('/components/onboarding/core/assets/javascripts/events/hide-fullscreen-event.js');
"use strict";

const BaseFullscreenEvent = svs.components.onboarding.core.events.BaseFullscreenEvent;
const FullscreenEventType = svs.components.onboarding.core.events.constants.FullscreenEventType;
class HideFullscreenEvent extends BaseFullscreenEvent {
  constructor(props) {
    super(FullscreenEventType.Hide, props);
  }
}

setGlobal('svs.components.onboarding.core.events.HideFullscreenEvent', HideFullscreenEvent);

 })(window);